(() => {
  'use strict';

  const selector = '[data-mypc-logo-animation]';

  const activateLogo = (logo) => {
    if (!logo || logo.dataset.mypcLogoReady === 'true') return;

    const animationClasses = (logo.dataset.mypcLogoAnimation || '')
      .split(/\s+/)
      .filter(Boolean);
    const requestedDelay = Number.parseInt(logo.dataset.mypcLogoDelay, 10);
    const delay = Number.isFinite(requestedDelay)
      ? Math.min(Math.max(requestedDelay, 0), 10000)
      : 1000;

    logo.dataset.mypcLogoReady = 'true';

    window.setTimeout(() => {
      logo.classList.remove('mypc-logo-animation--waiting');
      if (animationClasses.length) logo.classList.add(...animationClasses);
    }, delay);
  };

  const activateLogos = (root) => {
    if (root.matches && root.matches(selector)) activateLogo(root);
    root.querySelectorAll(selector).forEach(activateLogo);
  };

  const activatePageLogos = () => activateLogos(document);

  if (document.readyState === 'complete') {
    activatePageLogos();
  } else {
    window.addEventListener('load', activatePageLogos, { once: true });
  }

  document.addEventListener('shopify:section:load', (event) => {
    activateLogos(event.target);
  });
})();
